// import { colors } from "@mui/material";
// color names supported by https://colornamer.robertcooper.me/

const baseTheme = {
  palette: {
    primary: {
      main: "#FE3B00"
      // main: "#023048",
    },
    secondary: {
      main: "#C7CEE5",
      light: "#F0F2FA"
    },
    backgroundGrey: {
      main: "#FAFAFA"
    },
    lightGrey: {
      main: "#8E8E8E"
    },
    whiteColor: {
      main: "#FFF"
    },
    blackColor: {
      main: "#0000"
    },
    success: {
      main: "#28a745",
    },
    warning: {
      main: "#FF8800"
    }
  },
  typography: {
    fontFamily: `"Noto Sans Arabic",sans-serif`
  },
  spacing: 1
}

const LTRTheme = {
  ...baseTheme,
  direction: 'ltr',
};

const RTLTheme = {
  ...baseTheme,
  direction: 'rtl',
};

export {
  LTRTheme,
  RTLTheme
};
